(function () {
  function initPalette(section) {
    if (section.getAttribute('data-sova-palette-ready') === 'true') return;
    section.setAttribute('data-sova-palette-ready', 'true');

    var chips = section.querySelectorAll('[data-sova-palette-filter]');
    var palettes = section.querySelectorAll('[data-sova-palette]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-sova-palette-filter');

        chips.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        chip.classList.add('is-active');
        chip.setAttribute('aria-selected', 'true');

        palettes.forEach(function (palette) {
          var show = filter === 'all' || palette.getAttribute('data-sova-palette') === filter;
          palette.classList.toggle('is-hidden', !show);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sova-palette-section]').forEach(initPalette);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-sova-palette-section]');
    if (section) initPalette(section);
  });
})();
